/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
// import { Alert } from "components/elements";
import config from "config";
import jsonToFormData from "lib/jsonToFormData";
import session from "utils/session";

const setAppError = (e, message) => {
  if (message) {
    alert(message);
  }
  // try {
  //   // return Promise.reject(e);
  // } catch (error) {
  //   // return Promise.reject({ e, message });
  // }
};

const modifiedPath = (path) => {
  if (!path) return;
  const splitedPath = path.split("?");
  const lang = window.localStorage.getItem("lang") || "en";
  const addedLang = `${splitedPath[0]}?lang=${lang}${splitedPath[1] ? `&${splitedPath[1]}` : ""
    }`;
  return addedLang;
};

class Api {
  constructor() {
    this.http = axios.create({
      baseURL: `${config.REACT_APP_API_HOST}`,
      timeout: 60000,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.http.interceptors.request.use(
      async (config) => {
        return {
          ...config,
          headers: this.prepareRequestHeaders(config.headers),
          timeout: config?.data?.timeout || 60000,
          params: this.prepareRequestParams(
            config.params,
            config.isFormData || false
          ),
          data: this.prepareRequestParams(
            config.data,
            config.isFormData || false
          ),
        }
      },
      null || undefined
    );

    this.http.interceptors.response.use(
      (response) => {
        if (!response.data?.status?.code) {
          return this.handleSuccess(response);
        }

        if (response.data.status.code.substring(0, 1) === "2") {
          return this.handleSuccess(response);
        }

        return this.handleError(response);
      },
      (error) => {
        if (error?.response?.status === 403) {
          return this.handleSuccess(error);
        }

        return Promise.reject(error);
      }
    );
  }

  prepareRequestHeaders(headers) {
    const token = session.getAuthToken();
    const companyId = session.getCurrentCompany();
    const actionId = session.getCurrentEmployee();
    const lang = (window.localStorage.getItem("lang") || "en").toUpperCase();
    return {
      ...headers,
      lang,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(companyId ? { companyId: companyId } : {}),
      ...(actionId ? { actionId: actionId } : {}),
      ...(actionId ? { employeeId: actionId } : {}),
    };
  }

  prepareRequestParams = (params, isFormData) => {
    if (!params) return;
    if (isFormData)
      return jsonToFormData(params, {
        transfromPropName: (key) => key,
        showLeafArrayIndexes: false,
      });

    return params;
  };

  prepareResponseData(data) {
    return data;
  }

  handleSuccess(response) {

    if (response?.headers?.["content-type"] === "application/octet-stream") {
      return response;
    } else if (response?.response?.status == '403') {
      return Promise.resolve(response);
    } else {
      return { ...response, data: this.prepareResponseData(response.data) };
    }
  }

  onUnauthorized(e) {
    const { response } = e;
    return setAppError(e, response?.data?.message);
  }

  onNotFound(e) {
    const { response } = e;
    return setAppError(e, response?.data?.message);
  }

  onBadRequest(e) {
    const { response } = e;
    return setAppError(e, response?.data?.message);
  }

  onValidateFailed(e) {
    const { response } = e;
    if (response?.data?.errors && Array.isArray(response?.data?.errors)) {
      (response?.data?.errors || []).forEach((error) => alert(error.message));
      let messages = JSON.stringify(response?.data?.errors, null, 2);
      return Promise.reject({ ...e, messages });
    }
    return setAppError(
      e,
      JSON.stringify(response?.data?.message || response?.data?.errors, null, 2)
    );
  }

  onServerError(e) {
    return setAppError(e, "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
  }
  onBadcredentials(e) {
    return setAppError(e, "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง");
  }

  onRequestTimeout(e) {
    return setAppError(e, "INTERNET ล่าช้า กรุณาลองใหม่อีกครั้ง");
  }

  onNetworkError(e) {
    return setAppError(
      e,
      "การเชื่อมต่อกับเซิฟเวอร์มีปัญหา กรุณาลองใหม่อีกครั้งภายหลัง"
    );
  }

  handleError(e) {
    const { response } = e;
    if (response) {
      console.log("resp", response);
      if (response.data == "Access denied") {
        return { ...response, data: this.prepareResponseData(response.data) };
      }

      const { code } = response.data;
      if (code === "unauthorized") return this.onUnauthorized(e);
      if (code === "not_found") return this.onNotFound(e);
      if (code === "server_error") return this.onServerError(e);
      if (code === "bad_request") return this.onBadRequest(e);
      if (code === "validate_failed") return this.onValidateFailed(e);
      if (code === "ERR_NETWORK") return this.onServerError(e);
      // if (code === "ERR_BAD_REQUEST") return this.onNotFound(e);
      const error = { ...e, response: this.prepareResponseData(response) };
      // console.log("response", response);
      // if (response.status == '403') return setAppError(e, "แกไม่มีสิทธิ !!");

      if (response.data === "Bad credentials") return this.onBadcredentials(e);
      // return Promise.reject(error);
      // return this.handleSuccess(error)
    } else {
      if (/timeout/.test(e.message)) return this.onRequestTimeout(e);
      if (/Network/.test(e.message)) return this.onNetworkError(e);

      return Promise.reject(e);
    }
  }

  get(path, params = {}, options = {}) {
    return this.http.get(modifiedPath(path), { params, ...options });
  }

  post(path, params, options = {}) {
    const actionId = session.getCurrentEmployee();
    return this.http.post(modifiedPath(path), { ...params, ...(actionId ? { actionId } : {}), }, options);
  }

  put(path, params, options = {}) {
    const actionId = session.getCurrentEmployee();
    return this.http.put(modifiedPath(path), { ...params, ...(actionId ? { actionId } : {}), }, options);
  }

  patch(path, params, options = {}) {
    return this.http.patch(modifiedPath(path), params, options);
  }

  delete(path, params) {
    return this.http.delete(modifiedPath(path), { params });
  }
}

export default new Api();
